<template>
  <div>
    <b-form-textarea rows="2" max-rows="10" v-model="stringValue">
      <!-- newline separated data here which we convert to/from an array -->
    </b-form-textarea>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      stringValue: this.value.join("\n")
    }
  },
  watch: {
    // Watch for changes in stringValue and emit the updated array
    stringValue(v) {
      const val = v.split("\n").map(line => line.trim()).filter(line => line !== "");
      this.$emit('input', val);
    },
    // Watch for changes in the `value` prop and update stringValue accordingly
    value(newVal) {
      this.stringValue = newVal.join("\n");
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/NewlineEditor.vue